import { MenuItem } from "@mui/material";
import { withStyles } from "@mui/styles";

export const StyledMenuItem = withStyles({
  root: {
    fontSize: "14px",
  },
})(MenuItem);
